import Health from './svg/HealthIcon.svelte';
import Impact from './svg/ImpactIcon.svelte';
import Characters from './svg/Characters.svelte';
import Ceo from './svg/Ceo.svelte';
import HrManager from './svg/HrManager.svelte';
import CallCenterRep from './svg/CallCenterRep.svelte';
import Worker from './svg/Worker.svelte';
import PlayButton from './PlayButton.svelte';
import CeoButton from './CeoButton.svelte';
import HrManagerButton from './HrManagerButton.svelte';
import WorkerButton from './WorkerButton.svelte';
import CallCenterRepButton from './CallCenterRepButton.svelte';
import RandomButton from './RandomButton.svelte';
export default {
    health: Health,
    impact: Impact,
    characters: Characters,
    ceo: Ceo,
    hrmanager: HrManager,
    callcenterrep: CallCenterRep,
    worker: Worker,
    playbutton: PlayButton,
    ceobutton: CeoButton,
    hrmanagerbutton: HrManagerButton,
    workerbutton: WorkerButton,
    callcenterrepbutton: CallCenterRepButton,
    randombutton: RandomButton,
};